import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import {reduxForm} from 'redux-form';

import {signIn} from '../actions/index';

class SignIn extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state= {
            show: false
        };
        this.ShowPass = this.ShowPass.bind(this);
    }
    componentDidMount(){
        $('.errorForm').hide();
    }
    ShowPass(){
        this.setState({
            show: !this.state.show
        })
    }
    SubmitForm(props){
        this.props.signIn(props)
            .then((response)=>{
                if(response.payload.data.is_admin){
                    localStorage.setItem('id_token_admin', response.payload.data.token);
                    this.context.router.push('/dashboard');
                }else{
                    $('.errorForm').show();
                }
            });
    }
    render() {
        const { fields: {
            username,
            password}, handleSubmit} = this.props;
        return (
            <div>
                <div className="text-center block-sign-in-title clearfix">
                    <p className="">Live Language Learning</p>
                </div>
                <div className="container">
                    <div className="col-md-4 col-md-offset-4 block-sign-in">
                        <form onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                            <div className={ username.touched && !username.valid ? 'form-group input-name has-error' : 'form-group input-name'}>
                                <input type="email"
                                       name="username"
                                       className="form-control"
                                       id="username"
                                       placeholder="Email"
                                    {...username}
                                />
                            </div>
                            <div  className={ password.touched && !password.valid ? 'form-group input-password has-error' : 'form-group input-password'}>
                                <input type={this.state.show ? "text" : "password" }
                                       className="form-control"
                                       name="password"
                                       id="password"
                                       placeholder="Password"
                                    {...password}
                                />
                                <span className="glyphicon glyphicon-eye-open" onClick={this.ShowPass} />
                            </div>
                            <div>
                                { this.props.user.error ?  <p className="errorForm">Incorrect login or password</p> : ''}
                                <p className="errorForm">Incorrect login or password</p>
                            </div>
                            <button type="submit" className="btn btn-primary">Sign In</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
};

function  mapStateToProps(state) {
    return{
        user: state.user
    }
}
function validate(values) {
    const errors = {};
    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!values.username || !re.test(values.username)){
        errors.username = 'Enter a email'
    }
    if(!values.password){
        errors.password = 'Enter a password'
    }
    return errors;
}
export default reduxForm({
    form: 'SignIn',
    fields: ['username', 'password'],
    validate
}, mapStateToProps, {signIn})(SignIn);


// WEBPACK FOOTER //
// ./src/components/signIn.js